module.exports = __webpack_public_path__ + "img/8.53d8a47d.jpg";